import { useTranslation } from 'react-i18next';
import { Box, Heading, Text, Image } from '@chakra-ui/react';

interface ErrorPageProps {
  /** 大きく表示するエラーコード。未指定なら数字見出しを表示しない（案内画面向け） */
  errorCode?: number;
  title?: string;
  message?: string;
  /** ルートの最小高さ。ウィジェット内などコンテナに収める場合は "100%" を指定する */
  minHeight?: string;
}

export const ErrorPage = ({
  errorCode,
  title,
  message,
  minHeight = '100vh',
}: ErrorPageProps) => {
  const { t } = useTranslation();

  const defaultTitle = errorCode === 404 ? t('error.notFound.title') : t('error.generic.title');
  const defaultMessage =
    errorCode === 404 ? t('error.notFound.message') : t('error.generic.message');

  return (
    <Box
      display="flex"
      h="100%"
      minH={minHeight}
      w="100%"
      overflowY="auto"
      alignItems="center"
      justifyContent="center"
      bg="gradientSecondary"
      p={5}
    >
      <Box
        maxW={{ base: '100%', sm: 'md' }}
        borderRadius="3xl"
        bg="white"
        px={{ base: 6, sm: 12 }}
        py={{ base: 8, sm: 12 }}
        textAlign="center"
        boxShadow="lg"
      >
        <Box mb={6}>
          <Image
            src="/digitane.webp"
            alt="Digitane"
            mx="auto"
            w={30}
            h={30}
            objectFit="contain"
            opacity={0.8}
          />
        </Box>
        {errorCode !== undefined && (
          <Heading
            as="h1"
            m={0}
            bg="gradientPrimary"
            bgClip="text"
            fontSize={{ base: '7xl', sm: '8xl' }}
            fontWeight="bold"
            lineHeight="none"
            color="transparent"
          >
            {errorCode}
          </Heading>
        )}
        <Heading
          as={errorCode === undefined ? 'h1' : 'h2'}
          my={4}
          mb={3}
          fontSize={{ base: 'xl', sm: '2xl' }}
          fontWeight="semibold"
          color="gray.900"
        >
          {title || defaultTitle}
        </Heading>
        <Text
          my={0}
          border="none"
          bg="transparent"
          p={0}
          fontSize={{ base: 'sm', sm: 'md' }}
          lineHeight="relaxed"
          color="gray.600"
          boxShadow="none"
        >
          {message || defaultMessage}
        </Text>
      </Box>
    </Box>
  );
};
